<template>
  <q-menu
    ref="tooltipWithShowMoreOption"
    v-model="show"
  >
    <div class="tooltip-content gordita-500-11-m">
      <div class="tooltip-content-white">
        <div
          v-for="item in itemsList.slice(0, itemsToDisplay)"
          :key="item"
        >
          {{ item }}
        </div>
      </div>
      <div
        v-if="itemsList.length > maxItemsToDisplay"
        class="seeMoreLess"
      >
        <div
          v-if="seeMore"
          @click="showContent()"
        >
          See more
          <q-icon
            size="16px"
            class="seeMore uil uil-angle-down"
          />
        </div>
        <div
          v-if="!seeMore"
          class="seeLess"
          @click="hideContent()"
        >
          See less
          <q-icon
            size="16px"
            style="padding-bottom: 1px"
            class="seeLess uil uil-angle-up"
          />
        </div>
      </div>
    </div>
  </q-menu>
</template>

<script>
export default {
  name: 'TooltipWithShowMoreOption',
  props: {
    itemsList: {
      type: Array,
    },
    maxItemsToDisplay: {
      type: Number,
    },
    value: {
      type: Boolean,
    },
  },
  emits: ['update:model-value'],
  data() {
    return {
      seeMore: true,
      itemsToDisplay: this.maxItemsToDisplay,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('update:value', newValue);
      },
    },
  },
  methods: {
    showContent() {
      this.itemsToDisplay = this.itemsList.length;
      this.seeMore = false;
      this.$nextTick(() => this.$refs.tooltipWithShowMoreOption.updatePosition());
    },
    hideContent() {
      this.itemsToDisplay = this.maxItemsToDisplay;
      this.seeMore = true;
      this.$nextTick(() => this.$refs.tooltipWithShowMoreOption.updatePosition());
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip-content {
  background-color: #373737;
  padding: 8px 12px;
}

.seeMoreLess {
  cursor: pointer;
  margin-top: 8px;
  color: $-dark--theme--text-light-text-primary;
  font-size: 11px;
  display: inline-block;
  width: fit-content;
}

.seeMoreLess:hover {
  display: block;
  position: relative;
  border-bottom: 0.5px solid $-dark--theme--text-light-text-primary;
}

.tooltip-content-white {
  color: $-system-app-white;
}
</style>
